import { Suspense } from 'react';
import cn from 'classnames';
import { Grid } from 'ht-styleguide';
import lottieFile from '@public/_nextassets_/images/homehub/recommendationLoadingAnimation.json';
import { TLoaderProps } from './recommendation.types';
import styles from './recommendation.module.scss';
import dynamic from 'next/dynamic';

// Dynamically import the Lottie component
const Lottie = dynamic(() => import('react-lottie-player'), { ssr: false });

const Loader = ({ customerFirstName = '' }: TLoaderProps) => (
  <div className={cn(styles.animation, styles.loadingPage)}>
    <Grid.FullWidth classes={cn('marginAuto paddingTop-large paddingBottom-large', styles.loadingContainer)}>
      <Grid.Row classes="marginAuto text-align-center">
        <Grid.Column sm={4} md={6} mdOffset={1} lg={6} lgOffset={3}>
          <h2 className={cn(styles.negativeMarginBottom, 'n000')}>
            <h2 className="n000 marginAuto">Thank you for sharing your information{customerFirstName ? `, ${customerFirstName}!` : '!'} </h2>
          </h2>
        </Grid.Column>
        <Grid.Column sm={4} md={8} lg={4} lgOffset={4} classes="marginAuto paddingBottom-small">
          <Suspense fallback={<div>Loading animation...</div>}>
            <Lottie loop animationData={lottieFile} play className={styles.lottieImage} />
          </Suspense>
          <p className={cn(styles.negativeMarginTop, 'n000 font-weight-medium')}>Generating recommendations for you...</p>
        </Grid.Column>
      </Grid.Row>
    </Grid.FullWidth>
  </div>
);

export default Loader;
